//#region src/index.ts
function e(e) {
	return (t, r, a) => (o) => i(n(e)(t, r, a), o);
}
function t(e, t = !1) {
	return (n) => (a) => i(r(e)(n), a, t);
}
var n = (e) => (t, n, r) => `${e}/${t}/${r || t}Service.php?jsoncall=${n}`, r = (e) => (t) => e.replace(/\/engine$/, "") + t;
async function i(e, t, n = !1) {
	try {
		let r = await fetch(e, {
			method: n ? "GET" : "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json"
			},
			body: n ? null : JSON.stringify(t)
		});
		if (r.status !== void 0 && r.status !== 200) {
			let e = Error(r.statusText);
			return e.status = r.status, Promise.reject(e);
		}
		let i = await r.json();
		return i.error && i.error !== "0" && i.error !== 0 ? Promise.reject({
			code: i.error,
			msg: i.ErrorString,
			data: i
		}) : i;
	} catch (e) {
		return Promise.reject(e);
	}
}
async function a(e) {
	return fetch(e, { method: "GET" }).then((e) => e.json());
}
function o(e, t, n) {
	try {
		if (e && t && n) {
			let r = JSON.stringify(n);
			window[e].setItem(t, r);
		}
	} catch {}
}
function s(e, t) {
	try {
		let n = window[e].getItem(t);
		return n === null ? void 0 : JSON.parse(n);
	} catch {
		return;
	}
}
function c(e, t) {
	try {
		return window[e].removeItem(t), !0;
	} catch {
		return !1;
	}
}
function l(e) {
	try {
		return window[e].clear(), !0;
	} catch {
		return !1;
	}
}
var u = "localStorage", d = "sessionStorage";
//#endregion
export { u as LOCAL_STORAGE, d as SESSION_STORAGE, i as callService, l as clearStorage, a as getJSON, s as getStorage, t as handler, r as handlerUrl, c as removeStorageKey, e as service, n as serviceUrl, o as setStorage };

//# sourceMappingURL=index.js.map